import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import FilterSelect from "./FilterSelect";
import { getForm } from "../../../../services/restAPI/RestApi";
import "./FilterSettings.less";
import { Message, Switch, Button, Radio, RadioGroup, Input } from "../../../BP2Components";
import { getFormStructure } from "../../../../services/restAPI/FormsV3";
import { useIntl } from "react-intl";

const { Option } = Select;

const FilterSettings = ({ value }) => {
   const intl = useIntl();
   const dispatch = useDispatch();
   const [settings, setSettings] = useState({
      ...value,
   });
   const [elements, setElements] = useState([]);

   const handleChangeInput = (name) => (e) => {
      e.preventDefault();
      const inputVal = e?.target?.value;
      setSettings((prevSettings) => ({
         ...prevSettings,
         [name]: inputVal,
      }));
   };

   const handleRadioChange = (e) => {
      if (e.target.value === "vertical") {
         setSettings((prevSettings) => ({
            ...prevSettings,
            [e.target.name]: e.target.value,
            mdWidth: 12,
            lgWidth: 6,
            xlWidth: 6,
         }));
      } else if (e.target.value === "horizontal") {
         setSettings((prevSettings) => ({
            ...prevSettings,
            [e.target.name]: e.target.value,
            mdWidth: 24,
            lgWidth: 24,
            xlWidth: 24,
         }));
      }
   };

   const handleChange = (name) => (value) => {
      setSettings((prevSettings) => ({ ...prevSettings, [name]: value }));
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
   };

   useEffect(() => {
      if (!value?.formId) return;
      const idStr = String(value.formId);
      const isV3 = idStr.length > 10;
      if (isV3) {
         getFormStructure(value.formId)
            .then((res) => {
               const tabsElements = res?.data?.fields;
               setElements(tabsElements);
            })
            .catch(() =>
               Message.error(intl.formatMessage({ id: "formComplete.getFormStructureError" })),
            );
      } else {
         getForm(value.formId, null, null, null, null, true)
            .then((res) => {
               const tabsElements = res?.data?.default?.mainForm?.forms_data?.tab.map((singleTab) =>
                  Object.values(singleTab.elements),
               );
               const allElements = [...new Set(...tabsElements)];
               setElements(allElements);
            })
            .catch(() =>
               Message.error(intl.formatMessage({ id: "formComplete.getFormStructureError" })),
            );
      }
   }, [value?.formId]);

   return (
      <form onSubmit={handleSubmit}>
         <div className="widget-settings">
            <div className="widget-settings__inner">
               <label className="widget-settings__inner__label" key="formId">
                  <IntlMessages id="settings.filterFormId" />:
                  <Input
                     type="text"
                     name="formId"
                     defaultValue={value.formId}
                     onChange={handleChangeInput("formId")}
                  />
               </label>
               <div className="widget-settings__inner__label" key="layout">
                  <IntlMessages id="settings.filterLayout" />:
                  <RadioGroup
                     buttonStyle="solid"
                     optionType="button"
                     onChange={handleRadioChange}
                     defaultValue={value.layout || "vertical"}
                     name="layout"
                  >
                     <Radio value="vertical">
                        <IntlMessages id="settings.layoutVertical" />
                     </Radio>
                     <Radio value="horizontal">
                        <IntlMessages id="settings.layoutHorizontal" />
                     </Radio>
                  </RadioGroup>
               </div>
               <label className="widget-settings__inner__label" key="availablePresets">
                  <IntlMessages id="settings.availablePresets" />:
                  <Select
                     name="availablePresets"
                     defaultValue={value.availablePresets}
                     onChange={handleChange("availablePresets")}
                  >
                     <Option value="private">
                        <IntlMessages id="presets.private" />
                     </Option>
                     <Option value="public">
                        <IntlMessages id="presets.public" />
                     </Option>
                     <Option value="both">
                        <IntlMessages id="presets.both" />
                     </Option>
                  </Select>
               </label>
               <label className="widget-settings__inner__label" key="showFilterButton">
                  <IntlMessages id="settings.showFilterButton" />:
                  <Switch
                     name="showFilterButton"
                     onChange={handleChange("showFilterButton")}
                     defaultChecked={value.showFilterButton}
                  >
                     <IntlMessages id="settings.openInNewTab" />
                  </Switch>
               </label>

               {/* Change this option to proper name: addPresetButtonsVisible or arePresetsVisible */}
               <label className="widget-settings__inner__label" key="isSaveAsVisible">
                  <IntlMessages id="settings.isSaveAsVisible" />:
                  <Switch
                     name="isSaveAsVisible"
                     onChange={handleChange("isSaveAsVisible")}
                     defaultChecked={value.isSaveAsVisible}
                  >
                     <IntlMessages id="settings.openInNewTab" />
                  </Switch>
               </label>
               <label className="widget-settings__inner__label" key="filterSelect">
                  <IntlMessages id="settings.filterSelect" />:
               </label>
               <FilterSelect
                  connections={value?.connections}
                  elements={elements}
                  setSettings={setSettings}
               />
            </div>
            <Button buttonType="primary" htmlType="submit">
               <IntlMessages id="global.preview" />
            </Button>
         </div>
      </form>
   );
};

export default FilterSettings;
